(function(){
  "use strict";
  console.log("[BS-Product] gallery v6.0 - force visible defense");

  var mainImg = document.getElementById("bsMainImage");
  var prevBtn = document.getElementById("bsGalleryPrev");
  var nextBtn = document.getElementById("bsGalleryNext");
  var visibleThumbs = [];
  var currentSlide = 0;
  var activeColorHandle = null;

  function handleize(s){
    return (s || "").toString().toLowerCase().trim()
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  }

  function getSets(){
    return Array.prototype.slice.call(document.querySelectorAll("[data-color-set]"));
  }

  function applyContainerStyles(s, isVisible){
    if (isVisible){
      s.style.setProperty("display", "flex", "important");
      s.style.setProperty("flex-wrap", "wrap", "important");
      s.style.setProperty("gap", "8px", "important");
      s.style.setProperty("margin-top", "14px", "important");
      s.style.setProperty("padding-bottom", "6px", "important");
      s.style.setProperty("max-width", "540px", "important");
      s.style.setProperty("width", "100%", "important");
      s.style.setProperty("visibility", "visible", "important");
      s.style.setProperty("opacity", "1", "important");
    } else {
      s.style.setProperty("display", "none", "important");
    }
  }

  function applyThumbStyles(t, isActive){
    t.style.setProperty("display", "block", "important");
    t.style.setProperty("width", "60px", "important");
    t.style.setProperty("height", "60px", "important");
    t.style.setProperty("visibility", "visible", "important");
    t.style.setProperty("opacity", "1", "important");
    t.style.setProperty("flex-shrink", "0", "important");
    t.style.setProperty("border-color", isActive ? "#c4877a" : "transparent", "important");
  }

  function showColorSet(colorHandle){
    activeColorHandle = colorHandle;
    var sets = getSets();
    var visibleSet = null;
    sets.forEach(function(s){
      if (s.dataset.colorSet === colorHandle){
        applyContainerStyles(s, true);
        s.removeAttribute("hidden");
        visibleSet = s;
      } else {
        applyContainerStyles(s, false);
      }
    });
    if (!visibleSet && sets[0]){
      applyContainerStyles(sets[0], true);
      visibleSet = sets[0];
    }
    if (visibleSet){
      visibleThumbs = Array.prototype.slice.call(visibleSet.querySelectorAll(".bs-gallery-thumb"));
      currentSlide = 0;
      visibleThumbs.forEach(function(t, i){
        if (i === 0){ t.classList.add("active"); applyThumbStyles(t, true); }
        else { t.classList.remove("active"); applyThumbStyles(t, false); }
      });
      if (visibleThumbs[0] && mainImg && visibleThumbs[0].dataset.img){
        mainImg.src = visibleThumbs[0].dataset.img;
      }
      console.log("[BS-Product] thumbs visiveis:", visibleThumbs.length);
    }
  }

  // DEFESA ATIVA: reaplica os estilos a cada 250ms
  // Contra qualquer outro script que tente esconder os thumbs
  function forceVisible(){
    if (!activeColorHandle) return;
    var sets = getSets();
    sets.forEach(function(s){
      if (s.dataset.colorSet === activeColorHandle){
        var currentDisplay = s.style.display;
        if (currentDisplay !== "flex"){
          applyContainerStyles(s, true);
        }
        var thumbs = s.querySelectorAll(".bs-gallery-thumb");
        thumbs.forEach(function(t){
          var d = t.style.display;
          if (d === "none" || d === "" || t.style.visibility === "hidden" || parseFloat(t.style.opacity || "1") < 1){
            var isActive = t.classList.contains("active");
            applyThumbStyles(t, isActive);
          }
        });
      }
    });
  }
  setInterval(forceVisible, 250);

  function gotoSlide(idx){
    if (visibleThumbs.length === 0) return;
    if (idx < 0) idx = visibleThumbs.length - 1;
    if (idx >= visibleThumbs.length) idx = 0;
    currentSlide = idx;
    visibleThumbs.forEach(function(t, i){
      if (i === idx){ t.classList.add("active"); applyThumbStyles(t, true); }
      else { t.classList.remove("active"); applyThumbStyles(t, false); }
    });
    if (visibleThumbs[idx] && mainImg && visibleThumbs[idx].dataset.img){
      mainImg.src = visibleThumbs[idx].dataset.img;
    }
  }

  document.addEventListener("click", function(e){
    var t = e.target.closest && e.target.closest(".bs-gallery-thumb");
    if (t){
      var idx = visibleThumbs.indexOf(t);
      if (idx !== -1) gotoSlide(idx);
    }
  });

  if (prevBtn) prevBtn.addEventListener("click", function(){ gotoSlide(currentSlide - 1); });
  if (nextBtn) nextBtn.addEventListener("click", function(){ gotoSlide(currentSlide + 1); });

  // ===== Variant logic =====
  var variantsScript = document.getElementById("bsVariantsData");
  var variants = [];
  try { variants = variantsScript ? JSON.parse(variantsScript.textContent) : []; } catch(e){}

  var labelsScript = document.getElementById("bsLabels");
  var labels = { add: "Añadir al Carrito", soldOut: "Agotado" };
  try { if (labelsScript) labels = Object.assign(labels, JSON.parse(labelsScript.textContent)); } catch(e){}

  var variantIdInput = document.getElementById("bsVariantId");
  var priceCurrentEl = document.getElementById("bsPriceCurrent");
  var priceOriginalEl = document.getElementById("bsPriceOriginal");
  var addBtn = document.getElementById("bsAddToCart");
  var stickyPriceEl = document.querySelector(".bs-sticky-price");
  var stickyOldEl = document.querySelector(".bs-sticky-old");

  function formatMoney(cents){
    var v = (cents/100).toFixed(2);
    var parts = v.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return "$ " + parts.join(".");
  }

  function getSelectedOptions(){
    var selected = [];
    document.querySelectorAll(".bs-option-group").forEach(function(group){
      var btn = group.querySelector(".bs-color-swatch.active, .bs-size-btn.active");
      if (btn) selected.push(btn.dataset.value);
    });
    return selected;
  }

  function findVariant(selected){
    return variants.find(function(v){
      return v.options.every(function(opt, i){ return opt === selected[i]; });
    });
  }

  function updateVariant(){
    var selected = getSelectedOptions();
    if (selected.length === 0) return;
    var v = findVariant(selected);
    if (!v) return;
    if (variantIdInput) variantIdInput.value = v.id;
    if (priceCurrentEl) priceCurrentEl.textContent = formatMoney(v.price);
    if (priceOriginalEl && v.compare_at_price && v.compare_at_price > v.price){
      priceOriginalEl.textContent = formatMoney(v.compare_at_price);
      priceOriginalEl.style.display = "";
    } else if (priceOriginalEl){
      priceOriginalEl.style.display = "none";
    }
    if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(v.price);
    if (stickyOldEl && v.compare_at_price && v.compare_at_price > v.price){
      stickyOldEl.textContent = formatMoney(v.compare_at_price);
      stickyOldEl.style.display = "";
    } else if (stickyOldEl){
      stickyOldEl.style.display = "none";
    }
    if (addBtn){
      if (v.available){ addBtn.disabled = false; addBtn.textContent = labels.add; }
      else { addBtn.disabled = true; addBtn.textContent = labels.soldOut; }
    }
    document.querySelectorAll(".bs-option-group").forEach(function(group, i){
      var label = group.querySelector(".bs-option-selected");
      if (label && selected[i]) label.textContent = selected[i];
    });
  }

  document.addEventListener("click", function(e){
    var sw = e.target.closest && e.target.closest(".bs-color-swatch");
    if (!sw) return;
    var group = sw.closest(".bs-option-group");
    if (!group) return;
    group.querySelectorAll(".bs-color-swatch").forEach(function(s){ s.classList.remove("active"); });
    sw.classList.add("active");
    var colorHandle = sw.dataset.colorHandle || handleize(sw.dataset.value);
    console.log("[BS-Product] cor clicada:", sw.dataset.value, "| handle:", colorHandle);
    showColorSet(colorHandle);
    updateVariant();
  });

  document.addEventListener("click", function(e){
    var btn = e.target.closest && e.target.closest(".bs-size-btn");
    if (!btn) return;
    var group = btn.closest(".bs-option-group");
    if (!group) return;
    group.querySelectorAll(".bs-size-btn").forEach(function(b){ b.classList.remove("active"); });
    btn.classList.add("active");
    updateVariant();
  });

  function initGallery(){
    var initialColor = document.querySelector(".bs-color-swatch.active");
    if (initialColor){
      var initialHandle = initialColor.dataset.colorHandle || handleize(initialColor.dataset.value);
      console.log("[BS-Product] cor inicial:", initialHandle);
      showColorSet(initialHandle);
    } else {
      var firstSet = document.querySelector("[data-color-set]");
      if (firstSet){
        applyContainerStyles(firstSet, true);
        visibleThumbs = Array.prototype.slice.call(firstSet.querySelectorAll(".bs-gallery-thumb"));
        activeColorHandle = firstSet.dataset.colorSet;
      }
    }
  }

  if (document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", initGallery);
  } else {
    initGallery();
  }

  var qtyInput = document.getElementById("bsQtyValue");
  var qtyMinus = document.getElementById("bsQtyMinus");
  var qtyPlus = document.getElementById("bsQtyPlus");
  if (qtyMinus) qtyMinus.addEventListener("click", function(){
    var v = parseInt(qtyInput.value) || 1;
    if (v > 1) qtyInput.value = v - 1;
  });
  if (qtyPlus) qtyPlus.addEventListener("click", function(){
    var v = parseInt(qtyInput.value) || 1;
    qtyInput.value = v + 1;
  });

  document.querySelectorAll(".bs-accordion-header").forEach(function(header){
    header.addEventListener("click", function(){
      var item = header.parentElement;
      var wasOpen = item.classList.contains("open");
      item.classList.toggle("open");
      var icon = header.querySelector(".bs-accordion-icon");
      if (icon) icon.textContent = wasOpen ? "+" : "−";
    });
  });

  var sticky = document.getElementById("bsStickyBuy");
  var stickyBuyBtn = document.getElementById("bsStickyBuyBtn");
  var atcRow = document.querySelector(".bs-purchase-row");
  if (sticky && atcRow){
    window.addEventListener("scroll", function(){
      var rect = atcRow.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight){
        sticky.classList.add("visible");
      } else {
        sticky.classList.remove("visible");
      }
    }, { passive: true });
  }
  if (stickyBuyBtn && addBtn){
    stickyBuyBtn.addEventListener("click", function(){ addBtn.click(); });
  }
})();
